




























































































































































































import { Product as ProductObj, WorkModule } from '@/models'
import ApiClient from '@/services/api-client'
import { Component, Vue } from 'vue-property-decorator'
import { MutationTypes } from '@/store/mutation-types'
import ApiGtag, { Category } from '@/services/api-gtag'

@Component
export default class Product extends Vue {
  private url = process.env.VUE_APP_KLDX_API_URL

  private product: ProductObj = {
    id: '',
    country: '',
    title: '',
    image: '',
    editorialProject: '',
    editorialProjectLabel: '',
    subject: '',
    subjectNpe: 'lengua',
    repository: {
      path: '',
      created: false,
      automaticCreation: true
    },
    totalUnits: 0,
    units: [],
    totalWorkModules: 0,
    workModules: []
  }

  private workModules: Array<WorkModule> = []

  private get _workModules(): WorkModule[] {
    return this.workModules
  }

  created() {
    ApiClient.getProduct(this.$router.currentRoute.params.productId)
      .then(async(product) => {
        ApiGtag.sendEvent(Category.Course, 'View course', `${product.id}/${product.title}`)
        this.product = product as ProductObj
        this.$store.commit(MutationTypes.SET_ACTIVE_PRODUCT, this.product)
        this.workModules = product.workModules || []
        if (this.$route.name === 'Product') {
          window.document.title = `${this.$i18n.t('pageTitle.product')} ${product.title} - LDX`
        }
      })
      .catch((err) => {
        console.error(err)
        this.workModules = []
      })
  }

  private downloadWorkModule(product: ProductObj, workModule: WorkModule) {
    ApiClient.downloadWorkModule(product, workModule)
  }

  private sendWorkModule(product: ProductObj, workModule: WorkModule, upload: boolean) {
    ApiClient.sendWorkModule(product, workModule, upload)
  }

  private createDirectLdx(product: ProductObj, workModule: WorkModule) {
    ApiClient.createDirectLdx(product, workModule)
  }

  private gtagDownload(product: ProductObj, workModule: WorkModule, downloadType: string) {
    ApiGtag.sendEvent(
      Category.Course,
      `download ${downloadType}`,
      `${product.editorialProject}/${product.id}/${workModule.code}`
    )
  }
}
